import { UseDisclosureReturn } from '@chakra-ui/react';

import { DeleteModal } from 'src/components/modal/delete-modal';
import { useRouterQuery } from 'src/hooks/use-router-query';
import { logger } from 'src/lib/logger';
import { labelConfig } from '../config';

interface DeleteCollectionModalProps extends UseDisclosureReturn {
  cid: number;
  type: 'REPPL' | 'STUDIO';
  isCollectionOwner?: boolean;
  onDelete?: () => void;
}

export function DeleteCollectionModal({
  cid,
  type,
  isCollectionOwner,
  ...props
}: DeleteCollectionModalProps) {
  const { rid } = useRouterQuery('rid');
  const config = labelConfig[type].collectionDelete(isCollectionOwner);
  const { isLoading, mutateAsync: deleteCollection } = config.hook(rid);

  function handleDeleteCollection(id: number) {
    try {
      deleteCollection({ id });

      if (props?.onDelete) {
        props.onDelete();
      }
    } catch (err) {
      logger.error(err);
    }
  }

  return (
    <DeleteModal
      {...props}
      isDeleting={isLoading}
      onOk={() => {
        if (cid) {
          handleDeleteCollection(cid);
        }
      }}
      title={config.title}
      text={config.text}
      cancelBtnText="Cancel"
      okBtnText={config.okBtnText}
    />
  );
}
